// Pure layout helpers for the call stage. The LiveKit room stays in the Stimulus controller.

export function initials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
}

// A camera tile shows video only while a track exists and is not muted.
export function showsVideo(hasVideo, muted) {
  return Boolean(hasVideo) && !muted
}

// Cover a quiet camera with initials, but keep the <video> in the layout.
// display:none pauses the decoder and the picture stays frozen after it returns.
export function tileMedia({ hasScreen, hasCamera, cameraMuted }) {
  const cameraOn = showsVideo(hasCamera, cameraMuted)
  const showScreen = Boolean(hasScreen)
  return {
    showScreen,
    showCamera: cameraOn && !showScreen,
    showAvatar: !showScreen && !cameraOn,
  }
}

// Screen share takes the stage. Otherwise every tile stays in the grid.
export function featuredIdentity(tiles) {
  const screen = tiles.find((tile) => tile.screen)
  return screen ? screen.identity : null
}
